import React from "react";
import OnlineTruckBooking from "../../components/service-pages/online-truck-booking/OnlineTruckBooking";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";
import { FaqsResponse } from "@vahak/core/dist/_services/faq.service";
import {
    getOnlineTruckBookingStaticProps,
    getOnlineTruckBookingPageLayout
} from "../../components/service-pages/constants/OnlineTruckBooking";

export default function OnlineTruckBookingPage({ faqs }: { faqs: FaqsResponse[] }) {
    return <OnlineTruckBooking faqs={faqs} />;
}

OnlineTruckBookingPage.getLayout = getOnlineTruckBookingPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await getOnlineTruckBookingStaticProps()),
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("servicePages")))
        }
    };
}
